import { useMemo, useRef } from 'react';
import Fuse from 'fuse.js';

/**
 *
 * A custom React Hook to do a in-memory fuzzy text search
 * using Fuse.js.
 */
const useSearchable = <T,>(data: T[], query: string | null | undefined, options: any) => {

  const fuseOptions = useRef({
    threshold: 0.1,
    distance: 400,
    ...options
  });

  const fuse = useMemo(()=> {
    return new Fuse(data, fuseOptions.current);
  },[data, fuseOptions]);

  const filtered =  useMemo(() => data && fuse.search(query || '').map(result => result.item),[fuse, query, data]);

  if(!data) return data;
  if(!query) return data;

  return filtered;
};

export default useSearchable;
